import { ListCreator } from './useScorableItemFilters.d';

export function compose(...fns: ListCreator[]): ListCreator {
  return rootNodes => {
    return fns.reduce((acc, fn) => fn(acc), rootNodes);
  };
}
